<template>
  <section>
    <graph></graph>
  </section>
</template>

<script>
import Graph from "../components/Graph";

export default {
  name: "home",
  components: {
    Graph
  }
};
</script>

<style lang="scss" scoped>
.next-steps {
  .fa-link {
    margin-right: 5px;
  }
}
</style>
